"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createChildWapp = createChildWapp;
exports.createMiddleware = createMiddleware;
exports["default"] = createClient;
exports.getConfig = getConfig;
exports.run = run;
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _wapplr = _interopRequireDefault(require("wapplr"));
var _wapplrReact = _interopRequireDefault(require("wapplr-react"));
var _setContents = _interopRequireDefault(require("../common/setContents"));
var _config = require("../common/config");
var _createChildWapp2 = _interopRequireWildcard(require("../common/createChildWapp"));
var _excluded = ["config", "parentWapp", "parentRoute"];
function getConfig() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _p$config = p.config,
    config = _p$config === void 0 ? {} : _p$config;
  var clientConfig = config.client || {};
  var commonConfig = (0, _config.getConfig)(p).config;
  var common = (0, _objectSpread2["default"])({}, commonConfig.common);
  var client = (0, _objectSpread2["default"])({}, clientConfig);
  return {
    config: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, config), {}, {
      common: common,
      client: client
    })
  };
}
function createClient() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _getConfig = getConfig(p),
    config = _getConfig.config;
  var wapp = p.wapp || (0, _wapplr["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, p), {}, {
    config: config
  }));
  (0, _wapplrReact["default"])({
    wapp: wapp
  });
  (0, _setContents["default"])({
    wapp: wapp
  });
  return wapp;
}
function createMiddleware() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // eslint-disable-next-line no-unused-vars
  var wapp = p.wapp || createClient(p);
  return [function middleware(req, res, next) {
    next();
  }];
}
var defaultConfig = {
  config: {
    globals: {
      DEV: typeof DEV !== "undefined" ? DEV : undefined,
      WAPP: typeof WAPP !== "undefined" ? WAPP : undefined,
      RUN: typeof RUN !== "undefined" ? RUN : undefined,
      TYPE: typeof TYPE !== "undefined" ? TYPE : undefined,
      ROOT: typeof ROOT !== "undefined" ? ROOT : "/",
      NAME: typeof NAME !== "undefined" ? NAME : undefined
    }
  }
};
function run() {
  var _p$config2;
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultConfig;
  if (p !== null && p !== void 0 && (_p$config2 = p.config) !== null && _p$config2 !== void 0 && _p$config2.globals && !p.config.globals.RUN) {
    var _p$config3;
    p.config.globals.RUN = ((_p$config3 = p.config) === null || _p$config3 === void 0 ? void 0 : _p$config3.globals.NAME) || "atonement-the-victim";
  }
  var _getConfig2 = getConfig(p),
    config = _getConfig2.config;
  var wapp = createClient((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, p), {}, {
    config: config
  }));
  var globals = wapp.globals;
  var DEV = globals.DEV;
  var app = wapp.client.app;
  app.use(createMiddleware((0, _objectSpread2["default"])({
    wapp: wapp
  }, p)));
  wapp.client.listen();
  if (typeof DEV !== "undefined" && DEV && module.hot) {
    app.hot = module.hot;
    module.hot.accept();
  }
  return wapp;
}
function createChildWapp() {
  return _createChildWapp.apply(this, arguments);
}
function _createChildWapp() {
  _createChildWapp = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
    var _config$globals;
    var p,
      _p$config4,
      config,
      parentWapp,
      parentRoute,
      rest,
      ID,
      wapp,
      response,
      _args = arguments;
    return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          p = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _p$config4 = p.config, config = _p$config4 === void 0 ? {} : _p$config4, parentWapp = p.parentWapp, parentRoute = p.parentRoute, rest = (0, _objectWithoutProperties2["default"])(p, _excluded);
          ID = ((_config$globals = config.globals) === null || _config$globals === void 0 ? void 0 : _config$globals.WAPP) || parentWapp.globals.WAPP + "atonement-the-victim";
          wapp = p.wapp || _createChildWapp2.savedChildren[ID] && _createChildWapp2.savedChildren[ID].wapp || createClient({
            config: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, config), {}, {
              globals: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, parentWapp.globals), {}, {
                WAPP: ID,
                NAME: "atonement-the-victim"
              }, config.globals || {})
            })
          });
          wapp.parentWapp = parentWapp;
          _context.next = 7;
          return (0, _createChildWapp2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, rest), {}, {
            ID: ID,
            wapp: wapp
          }));
        case 7:
          response = _context.sent;
          if (parentRoute) {
            if (response.wapp.target === "web") {
              response.wapp.client.history.push = function (to, state) {
                var newLocation = (0, _objectSpread2["default"])({}, typeof to === "string" ? response.wapp.client.history.parsePath(to) : to);
                newLocation.pathname = parentRoute + newLocation.pathname;
                parentWapp.client.history.push(newLocation, state);
              };
            }
          }
          return _context.abrupt("return", response);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _createChildWapp.apply(this, arguments);
}
if (typeof RUN !== "undefined" && RUN === "atonement-the-victim") {
  run();
}